import { Button } from '@/ui-kit'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/ui-kit/components/Dialog'
import { Trans } from '@lingui/react/macro'

type EndConversationDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirmEnd: () => void
}

export function EndConversationDialog({ open, onOpenChange, onConfirmEnd }: EndConversationDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Trans>Finish conversation</Trans>
          </DialogTitle>
          <DialogDescription>
            <div className="text-gray-80 py-4 text-sm">
              <Trans>
                Are you sure you want to finish this conversation? Once you do, you won't be able to continue talking in
                this chat.
              </Trans>
            </div>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="bordered" onClick={() => onOpenChange(false)}>
            <Trans>Continue talking</Trans>
          </Button>
          <Button variant="error" onClick={onConfirmEnd}>
            <Trans>Finish</Trans>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
